module.exports = __webpack_public_path__ + "img/ua.1f4f68f2.svg";